import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {getTimeOfMessage} from "../../pages/root/helpers";
import Typography from "@material-ui/core/Typography";
import MessageBox from "../../assets/img/message_box.png"

console.log(MessageBox)

const useStyles = makeStyles({
    root: {
        maxWidth: 300,
        backgroundImage: `url("${MessageBox}")`,
        backgroundSize: '100% 100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 220,
        height: 274,
    },
    body: {
        padding: '20px'
    },
    message: {
        fontWeight: 'bold',
        color: 'rgb(189, 159, 111)',
        textAlign: 'center',
        position: 'relative',
        fontFamily: 'DINPro-Bold',
    },
    meta: {
        marginTop: 30,
        color: 'white',
    }
})

const SocialWallMessage = ({message}) => {

    const {data, author, timestamp} = message
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.body}>
                <Typography variant='h5' className={classes.message}>{data}</Typography>
                <div className={classes.meta}>
                <Typography variant='body2'>
                    By {author ? author.FirstName + ' ' + author.LastName : ' Unknown user'}
                </Typography>
                <Typography variant='body2'>
                    On {getTimeOfMessage(timestamp)}
                </Typography>
                </div>
            </div>
        </div>
    );
};

export default SocialWallMessage;
